import { Injectable } from '@angular/core';

@Injectable({ providedIn:'root' })
export class ActionService {
  private actions: (() => void)[] = [];

  addAction(action: () => void) {
    this.actions.push(action);
  }

  getActions(): (() => void)[] {
    return this.actions;
  }

  clearActions() {
    this.actions = [];
  }

  dispatchActions() {
    const actions = this.getActions();
    actions.forEach(action => action());
    this.clearActions();
  }
}
